
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardHeader, CardDescription, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ConversationDetailPanel from "./ConversationDetailPanel";

const ConversationDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  if (!id) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Conversation Not Found</CardTitle>
          <CardDescription>No conversation ID was provided.</CardDescription>
        </CardHeader>
        <div className="p-6">
          <Button variant="outline" onClick={handleGoBack}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
          </Button>
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Button variant="outline" onClick={handleGoBack}>
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Conversations
      </Button>
      
      <ConversationDetailPanel conversationId={id} />
    </div>
  );
};

export default ConversationDetail;
